import React from 'react';
import dayjs from 'dayjs';
import './week-calendar-row.css';
import WeekCalendarRowCell from './week-calendar-row-cell';

const WeekCalendarRow = ({ ...props }) => {
    const { caption, items, startDate, compact, dayPos, onItemClick, hourStartMin, frames, stretchableIds, stretchMeasured } =
        props;
    const divCells = [];

    for (let i = 0; i < 7; i++) {
        if (!compact || i === dayPos) {
            divCells.push(
                <WeekCalendarRowCell
                    key={`cr-${i}`}
                    dayIndex={i}
                    items={items.filter((item) =>
                        dayjs(item.date).startOf('day').isSame(startDate.add(i, 'd').startOf('day'))
                    )}
                    onItemClick={onItemClick}
                    frames={frames}
                    stretchableIds={stretchableIds}
                    stretchMeasured={stretchMeasured}
                />
            );
        }
    }

    return (
        <div
            className={`week-calendar-row${compact ? ' week-calendar-row--compact' : ''}`}
            data-start-min={hourStartMin}
        >
            {compact ? null : (
                <WeekCalendarRowCell className='week-calendar-row-cell--time'>{caption}</WeekCalendarRowCell>
            )}
            {divCells}
        </div>
    );
};

export default WeekCalendarRow;
